(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["el-mobile-foundation"] && !Shopify.designMode) return;
  try {
    (() => {
 const wrapTables=(root)=>root.querySelectorAll('.s-page__body table,.shopify-policy__body table,.ela table,.customer table').forEach(table=>{if(table.closest('.el-table-scroll')||table.rows[0]?.cells.length<3)return;const wrap=document.createElement('div');wrap.className='el-table-scroll';table.before(wrap);wrap.append(table);if(table.scrollWidth>wrap.clientWidth){wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',table.caption?.textContent||table.querySelector('th')?.textContent||(document.documentElement.lang==='de'?'Tabelle':'Table'))}});
 const start=()=>{wrapTables(document);if(matchMedia('(max-width:749px), (prefers-reduced-motion:reduce)').matches){document.querySelectorAll('video[autoplay]').forEach(video=>{video.removeAttribute('autoplay');video.pause();video.controls=true;video.preload='none'})}};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',e=>wrapTables(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
